export default {

  required: {
    message : "Please enter first name.",
    fn      : (input)=> input.length,
  },

  length: {
    message : "First Name length must be maximum 200 characters.",
    fn      : (input)=> input.length < 200,
  }
}
